import { FunctionComponent } from "react";
import { LogoSkeleton } from "@components/layout/logo/logo-skeleton";
import AuthStore from "@helper/auth/auth-store";
import { useQuery } from "@apollo/client";
import { GQLMeQuery, GQLMeQueryVariables } from "queries/user.generated";
import { ME_QUERY } from "queries/user";
import { Link } from "@components/common/link/link";
import { useTheme } from "@components/common/hooks/theme";

export interface LogoProps {
    expanded: boolean;
}

export const Logo: FunctionComponent<LogoProps> = ({ expanded }) => {
    const { loading: loadingMe } = useQuery<GQLMeQuery, GQLMeQueryVariables>(ME_QUERY);
    const { user } = AuthStore.getState();
    const isAdmin = user?.role === "admin";
    const { mode } = useTheme();
    const logoUrl = mode === "dark" ? "/images/logo-white.png" : "/images/logo.png";

    if (loadingMe) return <LogoSkeleton expanded={expanded} />;

    return (
        <div className={expanded ? "px-2" : "size-8"}>
            <Link href={isAdmin ? "/admin-dashboard/users" : "/social"}>
                <img src={expanded ? logoUrl : "/images/logo-small.png"} className={expanded ? "h-5 lg:h-7" : "size-8"} />
            </Link>
        </div>
    );
};
